var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ws-button',{class:_vm.$style.btn,attrs:{"disabled":_vm.isDisabled,"color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.handleBtnClick($event)}}},[_vm._v(" "+_vm._s(_vm.$t("Agenda.rateTeam"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }